module.exports = __webpack_public_path__ + "static/media/Vela - DK Chcolate_White.08d66983.jpg";